import { defineStore } from 'pinia'
import cache from '../../utils/cache'
//  import { RouteRecordRaw } from 'vue-router'
import { getUserInfo, login, logout } from '../../api/user'
//  import router, { filterAsyncRoutes } from '@/router'
//  import { PageEnum } from '@/enums/pageEnum'
import { clearAuthInfo, getToken } from '../../utils/auth'
import { Message } from 'element-ui'
import configs from '@/config'
const TOKEN_KEY = configs.token_key

const useUserStore = defineStore({
    id: 'user',
    state: () => ({
        token: getToken() || '',
        // 用户信息
        userInfo: {},
        // 路由
        routes: [],
        // 权限
        perms: []
    }),
    getters: {},
    actions: {
        resetState () {
            this.token = ''
            this.userInfo = {}
            this.perms = []
        },
        login (playload) {
            return new Promise((resolve, reject) => {
                login({
                    account: playload.username.trim(),
                    password: playload.password,
                    main_dept_id: playload.main_dept_id,
                    terminal: 2
                }).then((data) => {
                    // Message.error(data.message)
                    //  console.log('===login====', data)
                    this.token = data.token
                    cache.set(TOKEN_KEY, data.token)
                    resolve(data)
                    //  cache.set(TOKEN_KEY, this.token)
                    // cache.set(TOKEN_KEY, JSON.stringify(data))
                }).catch((error) => {
                    // console.log('===login_error====', error)
                    cache.remove(TOKEN_KEY)
                    reject(error)
                })
            })
        },
        logout () {
            return new Promise((resolve, reject) => {
                logout()
                    .then(async (data) => {
                        this.token = ''
                        // await router.push('/login')
                        console.log('===logout====', data)
                        clearAuthInfo()
                        resolve(data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        getUserInfo () {
            return new Promise((resolve, reject) => {
                getUserInfo()
                    .then((data) => {
                        this.userInfo = data.user
                        this.perms = data.permissions
                        // this.routes = filterAsyncRoutes(data.menu)
                        this.routes = data.menu
                        this.statusCount = data.statusCount
                        resolve(data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        }
    }
})

export default useUserStore



// WEBPACK FOOTER //
// ./src/stores/modules/user.js